import React, {useEffect, useRef} from 'react';
import * as PropTypes from 'prop-types';
import {InputContainerStyle, InputTextStyle} from './input.styled';

export const BasicTextInput = ({
	value,
	placeholder,
	disabled,
	hasError,
	onClick,
	onBlur,
	onChange,
	callbackOnEnter,
	callback,
	modalView,
	width,
	maxLength,
	focusOnMount,
	cy,
	type,
}) => {
	const inputElem = useRef(null);

	// Focus input on mount if prop is passed
	useEffect(() => {
		if (focusOnMount) {
			inputElem.current.focus();
		}
	}, []);

	const handleOnFocus = e => {
		e.target.select();
	};

	const handleOnClick = e => {
		if (onClick) {
			onClick(e.target);
		}
	};

	const handleOnChange = e => {
		if (onChange) {
			onChange(e.target.value);
		}
	};

	const handleValidate = e => {
		const inputValue = e.target.value;
		if (onBlur) {
			onBlur(e);
		}

		if (callback) {
			// else we just call the mutation;
			callback(inputValue, e);
		}
	};

	const handleKeyPressInput = e => {
		if (e.key === 'Enter') {
			if (callbackOnEnter) {
				callbackOnEnter();
			}
			handleValidate(e);
		}
	};

	const inputState = disabled ? '' : hasError ? ' error' : '';

	return (
		<InputContainerStyle modalView={modalView}>
			<InputTextStyle
				ref={inputElem}
				className={inputState}
				type={type ? type : 'text'}
				placeholder={placeholder}
				value={value}
				tabIndex={0}
				onFocus={e => handleOnFocus(e)}
				onClick={e => handleOnClick(e)}
				onChange={e => handleOnChange(e)}
				onBlur={e => handleValidate(e)}
				onKeyDown={e => handleKeyPressInput(e)}
				disabled={disabled}
				width={width}
				modalView={modalView}
				data-cy={cy}
				maxLength={maxLength}
			></InputTextStyle>
		</InputContainerStyle>
	);
};

BasicTextInput.propTypes = {
	/**
	 * Focus the input on mount
	 */
	focusOnMount: PropTypes.bool,
	/**
	 * Information when no value has been set yet.
	 */
	placeholder: PropTypes.string,
	/**
	 * Disable the input the user can't insert a new value or edit the current one.
	 */
	disabled: PropTypes.bool,
	/**
	 * When the input is focused the current value is selected. And the cursor ready to receive text input
	 */
	onClick: PropTypes.func,
	/**
	 * On blue the input parse the value to change it to the hours format (1h 30m).
	 * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
	 */
	onBlur: PropTypes.func,
	/**
	 * Indicator to show that the input is in an invalid state
	 */
	hasError: PropTypes.bool,
	/**
	 * Action to execute if the validation is successful
	 */
	callback: PropTypes.func,
	/**
	 * Value of the input
	 */
	value: PropTypes.string,
	/**
	 * This is necessary to get the value of the input from the parent
	 */
	onChange: PropTypes.func,

	/**
	 * Same a the callback prop but only called when typing Enter
	 */
	callbackOnEnter: PropTypes.func,

	/**
	 * Specific styling for the scheduling modals
	 */
	modalView: PropTypes.bool,

	/**
	 * Width of the input
	 */
	width: PropTypes.string,

	/**
	 * The caracter limit supported
	 */
	maxLength: PropTypes.number,
	cy: PropTypes.string,

	type: PropTypes.string,
};

BasicTextInput.defaultProps = {
	disabled: false,
	hasError: false,
};
